<script>
import List from "@/resources/cog-catalog-item/List";

export default {
    mixins: [List],
    computed: {
        mwsConfigurationOptions() {
            return this.$store.getters.mwsConfigurationOptions.filter(
                (option) => option.second_marketplace_id || !option.value
            );
        },
    },
    data() {
        return {
            marketplaceIdKey: "second_marketplace_id",
            disableDelete: false,
            filter: {
                second_marketplace: 1,
            },
            catalogItemFilter: {
                second_marketplace: 1,
            },
        };
    },
};
</script>
